(function () {
  'use strict';

  var headerToggle = document.querySelector('.header-toggle');
  var navMain = document.querySelector('.nav-main');

  if (headerToggle && navMain) {
    headerToggle.addEventListener('click', function () {
      var open = navMain.classList.toggle('is-open');
      headerToggle.setAttribute('aria-expanded', open);
    });

    document.addEventListener('click', function (e) {
      if (navMain.classList.contains('is-open') && !headerToggle.contains(e.target) && !navMain.contains(e.target)) {
        navMain.classList.remove('is-open');
        headerToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    var id = a.getAttribute('href');
    if (id === '#') return;
    var target = document.querySelector(id);
    if (target) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (navMain && navMain.classList.contains('is-open')) {
          navMain.classList.remove('is-open');
          headerToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }
  });
})();
